/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import UserFormWrapper from "./UserFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as controlPanelActions from "../../../actions/controlPanelActions";
import * as appsActions from "../../../actions/appsActions";
import * as usersActions from "../../../actions/userActions";

class UsersPage extends Component {
	constructor(props) {
		super(props);
		this.appKey = this.props.match.params.appKey;
		this.actions = {
			CREATE: "create",
			UPDATE: "update",
			COPY: "copy",
		};
	}

	componentDidMount() {
		const { loadUsers } = this.props.appsActions;
		loadUsers(this.appKey);
	}

	getAppId = () => {
		let appId = "";
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			appId = app ? app.id : "";
		}
		return appId;
	};

	selectUser = userID => {
		const { usersActions } = this.props;
		usersActions.selectUser(userID);
	};

	reloadUsers = () => {
		const { appsActions, history } = this.props;
		appsActions.loadUsers(this.appKey);
		history.push(`/apps/${this.appKey}/users`);
	};

	loadUsers = () => {
		const { appsActions } = this.props;
		appsActions.loadUsers(this.appKey);
	};

	logError = error => {
		this.props.controlPanelActions.displayError(error.response.data.Message);
	};

	performGlobalAction(action, values, url, submitHandler) {
		const { globalActions } = this.props;
		const { createItem, updateItem } = globalActions;
		const data = {
			...values,
			appId: this.getAppId(),
		};
		const args = [data, url, this.reloadUsers, this.logError, submitHandler];
		switch (action) {
			case this.actions.CREATE:
				createItem(...args);
				break;
			case this.actions.COPY:
				createItem(...args);
				break;
			case this.actions.UPDATE:
				updateItem(...args);
				break;
			default:
				break;
		}
	}

	createItem = (values, submitHandler) => {
		this.performGlobalAction(this.actions.CREATE, values, `/apps/${this.appKey}/invite`, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		this.performGlobalAction(this.actions.UPDATE, values, `/apps/${this.appKey}/users/${itemId}`, submitHandler);
	};

	copyItem = (values, submitHandler) => {
		this.performGlobalAction(this.actions.COPY, values, `/apps/${this.appKey}/invite`, submitHandler);
	};

	deleteItem = (id, name) => {
		const { globalActions } = this.props;
		globalActions.deleteItem(`/apps/${this.appKey}/users/${id}`, this.loadUsers, this.logError, name);
	};

	renderGrid = () => {
		const { users } = this.props;

		return (
			<div>
				{users ? (
					<Grid
						defaultText="There are no users to display. Please create your first user..."
						pluralItemName="Users"
						items={users}
						fieldsToDisplay={["firstName", "lastName"]}
						data={this.props}
						delete={this.deleteItem}
					/>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { currentUser, selectedUser, users } = this.props;
		const { experiences } = this.props.experiences;

		return (
			<Page>
				{users ? (
					<GridFormSwitcher
						RenderCopy={UserFormWrapper}
						RenderEdit={UserFormWrapper}
						RenderNew={UserFormWrapper}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						experiences={experiences}
						currentUser={currentUser}
						selectUser={this.selectUser}
						selectedUser={selectedUser}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

UsersPage.propTypes = {
	match: PropTypes.any,
	experiences: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	usersActions: PropTypes.object,
	history: PropTypes.object,
	apps: PropTypes.array,
	users: PropTypes.array,
	appsActions: PropTypes.object,
	currentUser: PropTypes.object,
	selectedUser: PropTypes.object,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	users: state.apps.users,
	selectedUser: state.user.selectedUser,
	currentUser: state.user.user,
	experiences: state.experiences,
});

const mapDispatchToProps = dispatch => ({
	globalActions: bindActionCreators(globalActions, dispatch),
	appsActions: bindActionCreators(appsActions, dispatch),
	usersActions: bindActionCreators(usersActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UsersPage);
